import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<any> => {

  const idToken = localStorage.getItem('idToken');

  if (!idToken) {
    console.warn('tokenInterceptor - No se encontró un token en localStorage. Solicitando sin token.');
    return next(req);
  }

  // Clonar la solicitud y agregar el token Authorization
  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  return next(clonedRequest);
};
